import React, { Component } from 'react';
import { Table } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';


class EmployeeCustomerListing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // employeeId: parseInt(this.props.selector) > 0 ? this.props.selector : 0,
            data: []
        };
    }

    componentDidMount() {
        this.props.log('EmployeeCustomerListing.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('EmployeeCustomerListing.js/onSubmit');
        fetch('/api/reports/EmployeeCustomerListing', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        data: results.data,
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    getCSVdata = () => {
        this.props.log('EmployeeCustomerListing.js/getCSVdata');
        let retArray = [['Employee', 'Account Owner Customers', 'Processor Customers', 'Backup Customers'], ['', '', '']];
        this.state.data.forEach(employee => {
            const maxRows = Math.max(Math.max(employee.primary != null ? employee.primary.length : 1, employee.secondary != null ? employee.secondary.length : 1),employee.processor != null ? employee.processor.length : 1);
            let employeeArr = [...Array(maxRows + 1)].map(row => ['', '', '']);
            employeeArr[0][0] = employee.lastName + ', ' + employee.firstName;
            employeeArr[1][0] = (employee.team != null && employee.team !== '' ? employee.team : '(No Team)') +' - '+(employee.jobTitle != null && employee.jobTitle !== '' ? employee.jobTitle : '(No Title)')+' / '+(employee.role1 != null && employee.role1 !== '' ? employee.role1 : '(No Role)');
            if (employee.primary != null) employee.primary.forEach((client, index) => {
                employeeArr[index][1] = client.name;
            });
            if (employee.secondary != null) employee.secondary.forEach((client, index) => {
                employeeArr[index][3] = client.name;
            });
            if (employee.processor != null) employee.processor.forEach((client, index) => {
                employeeArr[index][2] = client.name;
            });
            retArray = retArray.concat(employeeArr);
        })
        this.props.passData(retArray, "employee-customer-listing");
    }

    render() {
        this.props.info('CustomerInfoListing.js/render');
        return (
            <>
                <Table>
                    <thead>
                        <tr>
                            <th>Employee</th>
                            <th>Account Owner Customers</th>
                            <th>Processor Customers</th>
                            <th>Backup Customers</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.map((employee, employeeIndex) => (
                            <tr key={employeeIndex} className="pb-2">
                                <td className="text-left">
                                    <h3>{employee.lastName}, {employee.firstName}</h3>
                                    <p className="font-weight-bold text-muted">{employee.team != null && employee.team !== '' ? employee.team : '(No Team)'} - {employee.jobTitle != null && employee.jobTitle !== '' ? employee.jobTitle : '(No Title)'} / {employee.role1 != null && employee.role1 !== '' ? employee.role1 : '(No Role)'}</p>
                                </td>
                                <td>
                                    {employee.primary != null ?
                                        <ul>
                                            {employee.primary.map((client, clientIndex) => (
                                                <li key={clientIndex}>{client.name}</li>
                                            ))}
                                        </ul> : <></>}
                                </td>
                                <td>
                                    {employee.processor != null ?
                                        <ul>
                                            {employee.processor.map((client, clientIndex) => (
                                                <li key={clientIndex}>{client.name}</li>
                                            ))}
                                        </ul> : <></>}
                                </td>
                                <td>
                                    {employee.secondary != null ?
                                        <ul>
                                            {employee.secondary.map((client, clientIndex) => (
                                                <li key={clientIndex}>{client.name}</li>
                                            ))}
                                        </ul> : <></>}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </>
        );

    }
}

export default EmployeeCustomerListing;
